export default __webpack_public_path__ + "static/media/broommagic.7ebbf9d6.png";